import { useRouter } from 'next/router'
import React from 'react'

import { Chat, SERVICES_URL, useLocale, useTranslation } from '@plandi/common'
import {
  useMutationSendMessageProfileFactoryChat,
  useQueryProfileFactoryChatMessages
} from '../common'
import { Link, Typography } from '@material-ui/core'

export const ProfileFactoryUserChat = () => {
  const router = useRouter()
  const chatId = router.query.chatId
  const { data: translate } = useTranslation()
  const locale = useLocale()
  const url = SERVICES_URL

  const sendMessageMutation = useMutationSendMessageProfileFactoryChat()
  const { data: chatMessages } = useQueryProfileFactoryChatMessages(
    Number(chatId)
  )

  const onSendMessage = (values: { message: string }) => {
    sendMessageMutation.mutate({
      chatId: Number(chatId),
      requestBody: { content: values.message }
    })
  }

  const linkBlock = () => {
    return (
      <div style={{ display: 'flex', gap: 5 }}>
        <Typography style={{ fontSize: 13 }}>
          {locale === 'ru' ? 'Чат заблокирован.' : 'Chat blocked.'}
        </Typography>
        <Link
          href={
            locale === 'ru'
              ? `${url.main}/ru${'/messages?tab=job&type=factory&page=1'}`
              : url.main + '/messages?tab=job&type=factory&page=1'
          }
        >
          {locale === 'ru' ? 'Управление чатами' : 'Chat management'}
        </Link>
      </div>
    )
  }

  return (
    <div>
      <Chat
        messages={chatMessages?.messages}
        onSendMessage={onSendMessage}
        disabled={chatMessages?.status === 'decline'}
        informationMessages={
          !chatMessages?.messages?.length
            ? [translate?.shop['no-messages']]
            : chatMessages?.status === 'decline'
            ? [linkBlock()]
            : []
        }
      />
    </div>
  )
}
